const Feature = ({
  featureName = '',
  enabled = false,
}: {
  featureName?: string;
  enabled?: boolean;
} = {}) => ({
  featureName: String(featureName),
  enabled: Boolean(enabled),
});

export type FeatureProps = ReturnType<typeof Feature>;

export default Feature;
